import { CircleMinus } from 'lucide-react';
import { Button } from '@/components/ui/button';

const MinusIcon = ({ dismissRow }: { dismissRow(): void }) => (
	<Button
		variant="outline"
		size="xs"
		className="rounded-full text-red-700 border-red-700 hover:bg-red-700 hover:text-white"
		onClick={dismissRow}
	>
		<CircleMinus className="w-5 h-5 inherit" />
		<span className="sr-only">Dismiss Icon</span>
	</Button>
);

export default MinusIcon;
